import styled from 'styled-components';

export const Container = styled.div`
    @media screen and ( min-width: 0px ) {
        .content {
            margin-bottom: 4em;

            .img-responsive {
                margin-bottom: 1em;
            }

            h2.title {
                text-align: center;
                margin-top: 1.5em;
                margin-bottom: 2em;
            }

            h2.desktop-text {
                width: fit-content;
                padding-bottom: 10px;
                margin: 0 auto;
                margin-top: 1em;
                border-bottom: 1px solid #333;
            }

            p {
                max-width: 745px;
                margin: 1em auto;
            }

            img {
                display: block;
                margin: 0 auto;
            }

            .video {
                display: flex;
                margin: 0 auto;
                flex-direction: column;
                width: 100%;
                max-width: 375px;
                height: auto;
                min-height: 209px;

                iframe {
                    width: 100%;
                    max-height: 209px;

                    & + iframe {
                        margin-top: 3em;
                    }
                }
            }

            .videos {
                display: none;
                width: 930px;
                max-width: 100%;
                
                ul {
                   list-style: none;
                   padding: 0;
                   display: flex;
                   flex-direction: column;
                   align-items: center;

                   li {
                    cursor: pointer;
                   }
                }
            }
        }
    }

    @media screen and ( min-width: 992px ) {
        .content {
            max-width: 100%;

            .video {
                width: 100%;
                max-width: 930px;
                height: auto;
                min-height: 520px;

                iframe {
                    width: 100%;
                    max-height: 520px
                }
            }

            .videos {
                display: block;
                ul {
                    flex-direction: row;

                    li + li {
                        margin-left: 1em;
                    }
                }
            }
        }
    }    
`